// StageMicrocopy — small utility component that renders the resolved
// action-oriented sub-line for a stage.
//
// Typically used inside StageChip (when size === 'lg') or as a standalone
// caption underneath an entity name. Style is muted by default; callers can
// override via `className`.
//
// Per specs/_product/dashboard-v2-stage-treatments.md.

import type { ReactNode } from "react";

export interface StageMicrocopyProps {
  /** Pre-resolved microcopy string (output of getStageLabel().microcopy). */
  text: string;
  /** Optional Tailwind class override; falls back to muted small caption. */
  className?: string;
  /** Render a leading icon / dot before the text if desired. */
  leading?: ReactNode;
}

export function StageMicrocopy({ text, className, leading }: StageMicrocopyProps) {
  if (!text) return null;
  return (
    <span
      className={className}
      style={{
        fontSize: 12,
        color: "var(--color-text-muted)",
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
      }}
    >
      {leading}
      {text}
    </span>
  );
}
